export default __webpack_public_path__ + "static/media/arraialIcon.9e53024c.svg";